var AdaptiveImage = require("../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "f16.e989f6bc.png","uri@2x": __webpack_public_path__ + "f16.98446e77.png","uri@3x": __webpack_public_path__ + "f16.f9a2b989.png",
    width: 61,
    height: 100
});